<div class="white-bg no-padding no-margin">
  <breadcrumbs>
    <breadcrumb [currentRoute]="true" label="{{'Fleet Averages' | translate | async}}"></breadcrumb>
  </breadcrumbs>
</div>
<div class="panel panel--components" style=" margin-left: 20px; margin-right: 20px; padding-top: 16px">
  <div class="search-toggle-container"
       style="margin-bottom:20px;  margin-left: 20px; margin-right: 20px;">

    <mat-form-field class="search-input"
                    [class.required-field]="showValidation && !SearchFilter.CustomerId">
      <mat-label>
        {{'Select Customer' | translate | async}}
        <span class="required-star">*</span>
      </mat-label>
      <input matInput
             type="text"
             
             (input)="customerChanged($event)"
             name="inputcustomer"
             [matAutocomplete]="auto2"
             [(ngModel)]="customerModel">

      <mat-autocomplete #auto2="matAutocomplete"
                        (optionSelected)="onSelectCustomer($event.option)">
        <mat-option *ngFor="let customer of _dropDownListsFiltered.customerList"
                    [value]="customer.Title">
          {{customer.Title}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="search-input"
                    [class.required-field]="showValidation && !SearchFilter.JobsiteId">
      <mat-label>
        {{'Select Job Site' | translate | async}}
        <span class="required-star">*</span>
      </mat-label>
      <mat-select [(value)]="selectedJobsite"
                  (selectionChange)="jobsiteChanged($event)"
                  name="jobsite">

        <mat-option *ngFor="let jobsite of _dropDownListsFiltered.jobSiteList"
                    [value]="jobsite">
          {{ jobsite.Title }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="search-input">
      <input type="text" placeholder="{{'Select Make' | translate | async}}" (input)="changedMake($event)" matInput name="inputMake"
             [matAutocomplete]="auto1" [(ngModel)]="makeModel">
      <mat-autocomplete #auto1="matAutocomplete"
                        (optionSelected)="onSelectMake($event.option)">
        <mat-option [value]="make.Title" *ngFor="let make of _dropDownListsFiltered.makeList">
          {{make.Title}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="search-input">
      <input type="text" placeholder="{{'Select Model' | translate | async}}" (input)="changedModel($event)" matInput name="inputModel"
             [matAutocomplete]="auto" [(ngModel)]="machineModel">
      <mat-autocomplete #auto="matAutocomplete"
                        (optionSelected)="onSelcetionModel($event.option)">
        <mat-option [value]="model.Title" *ngFor="let model of _dropDownListsFiltered.modelList ">
          {{model.Title}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <a class="button" style="margin-left: 15px; margin-right: 5px;" (click)="ResetFields();"><span class="button__text">{{'Reset' | translate | async}}</span></a>
    <a class="button button--primary" (click)="searchRecords(false)">
      <i class="material-icons button__icon">search</i><span class="button__text">{{'Search' | translate | async}}</span>
    </a>
  </div>
</div>
<div class="center" [hidden]="!isLoading">
  <mat-spinner></mat-spinner>
</div>
<div class="panel panel--components" style=" margin-left: 20px; margin-right: 20px;" [@fadeInOut]
     [hidden]="isLoading">
  <div class="panel__content no-padding sticky" *ngIf="FleetViewAveragesFiltered?.length > 0">
    <table class="table table--striped table--full-width">
      <thead>
        <tr>
          <th class="text-left text-padding">{{'Make' | translate | async}}</th>
          <th class="text-left text-padding">{{'Model' | translate | async}}</th>
          <th class="text-center text-padding">{{'Average Monthly SMU' | translate | async}}</th>
          <th class="text-center text-padding">{{'Average Monthly Propel Hours' | translate | async}}</th>
          <th class="text-center text-padding">{{'Average Daily Hours' | translate | async}}</th>
          <th class="text-center text-padding">{{'Edit' | translate | async}}</th>
          <th class="text-center text-padding" style="width: 80px;">
            <button mat-icon-button
                    type="button"
                    [disabled]="isRefreshing"
                    (click)="recalculate()"
                    [matTooltip]="'Refresh system-calculated values. Manual adjustments will be overwritten.' | translate | async">
              <mat-icon [class.spin]="isRefreshing">refresh</mat-icon>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-row-style"
            *ngFor="let item of FleetViewAveragesFiltered">

          <td class="text-left text-padding">
            {{ item.MakeName }}
          </td>

          <td class="text-left text-padding">
            {{ item.ModelName }}
          </td>

          <td class="text-center text-padding">
            <ng-container *ngIf="item.isEditing; else monthlyView">
              <input type="number" style="height: 30px; "
                     [(ngModel)]="item.AverageMonthlyHours">
            </ng-container>

            <ng-template #monthlyView>
              {{ item.AverageMonthlyHours }}
            </ng-template>
          </td>

          <td class="text-center text-padding">
            <ng-container *ngIf="item.isEditing; else propelView">
              <input type="number" style="height: 30px; "
                     [(ngModel)]="item.AveragePropelHours">
            </ng-container>

            <ng-template #propelView>
              {{ item.AveragePropelHours }}
            </ng-template>
          </td>

           <td class="text-center text-padding">
           

          
              {{ item.AverageMonthlyHours / 30.4 | number:'1.2-2' }}
           
          </td>

          <td class="text-center text-padding">
            <div>
              <!-- Edit -->
              <i *ngIf="!item.isEditing"
                 class="material-icons button__icon cursor-pointer"
                 (click)="editAverage(item)">
                edit
              </i>
            </div>
            <div class="flex-div">
              <!-- Save -->
              <i *ngIf="item.isEditing"
                 class="material-icons button__icon cursor-pointer"
                 title="Save"
                 (click)="saveAverage(item)">
                check
              </i>

              <!-- Cancel -->
              <i *ngIf="item.isEditing"
                 class="material-icons button__icon cursor-pointer"
                 title="Cancel"
                 (click)="cancelAverage(item)">
                close
              </i>
            </div>
          </td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="custom-paginator" *ngIf="FleetViewAveragesFiltered?.length > 0">

    <div class="page-size">
      <span>{{'Items per page' | translate | async}}:</span>
      <button mat-button [matMenuTriggerFor]="pageSizeMenu" class="page-size-btn">
        {{ recordsPerPage }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>

      <mat-menu #pageSizeMenu="matMenu" yPosition="above">
        <button mat-menu-item (click)="changePageSize(10)">10</button>
        <button mat-menu-item (click)="changePageSize(25)">25</button>
        <button mat-menu-item (click)="changePageSize(50)">50</button>
        <button mat-menu-item (click)="changePageSize(100)">100</button>
      </mat-menu>
    </div>

    <mat-paginator [hidePageSize]="true"
                   [pageIndex]="pageNumber"
                   [length]="totalResults"
                   [pageSize]="recordsPerPage"
                   (page)="onPageEvent($event)">
    </mat-paginator>

  </div>
</div>
